import type { SignalClass } from "../data/types"

export const SIGNAL_COLORS: Record<SignalClass, string> = {
  LEADER: "#14d8b4",
  CONSTRUCTIVE: "#56e6ce",
  NEUTRAL: "#5e6462",
  LAGGARD: "#eab308",
  STRESS: "#ef4444",
}

export function signalColor(sig: SignalClass | string) {
  return SIGNAL_COLORS[sig as SignalClass] || SIGNAL_COLORS.NEUTRAL
}
